import { RouteItem } from '@eastcoal/router/types/route'

import {
  TENDER_AUCTION_CREATE_PAGE_PATH,
  TENDER_AUCTION_LIST_PAGE_PATH
} from './constants/path'
import { TENDER_AUCTION_LIST_PAGE_UUID } from './constants/uuid'

export const tenderAuctionRoute: RouteItem = {
  title: '招标',
  hideChildrenInMenu: true,
  uuid: TENDER_AUCTION_LIST_PAGE_UUID,
  children: [
    {
      title: '招标列表',
      path: TENDER_AUCTION_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增招标',
      path: TENDER_AUCTION_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    }
  ]
}
